import { render, staticRenderFns } from "./balancesreport_main.vue?vue&type=template&id=22ee70a2&scoped=true"
import script from "./balancesreport_main.vue?vue&type=script&lang=js"
export * from "./balancesreport_main.vue?vue&type=script&lang=js"
import style0 from "./balancesreport_main.vue?vue&type=style&index=0&id=22ee70a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee70a2",
  null
  
)

export default component.exports